// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2TpOI","calendarButtons":"ClockData_calendarButtons__ie9Uq"};